module.exports = __webpack_public_path__ + "static/23-f4b6b03050d279558e9ccbf5bd6b2f89.jpg";